import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const FilterListRoundedIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon
        viewBox="0 0 24 24"
        sx={{
            color: COLORS.CERULEAN,
        }}
        {...props}
    >
        <path
            d="M11 18h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1M3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1m4 6h10c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1"
            stroke="none"
            fill="currentColor"
        />
    </SvgIcon>
)
